import { MapTo } from '@adobe/aem-react-editable-components';
import Offer, { OfferEditConfig } from './Offer';

export default MapTo('cob-corp-acquisition/components/creditonebank/offer')(Offer, OfferEditConfig);